import React from 'react';
import { IconProps } from '@/models/IconProps';

const HazardIcon: React.FC<IconProps> = ({ height = '24', width = '24', strokeColor = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.8627 9.37963C12.8731 8.89691 12.4846 8.5 12.0018 8.5C11.5192 8.5 11.1308 8.89656 11.1408 9.37907L11.2527 14.7536C11.2612 15.1602 11.5933 15.4855 12 15.4855C12.4066 15.4855 12.7386 15.1605 12.7473 14.7541L12.8627 9.37963Z"
        fill={strokeColor}
      />
      <path
        d="M11.2909 18.1906C11.4879 18.3967 11.7242 18.4998 12 18.4998C12.1818 18.4998 12.347 18.4531 12.4955 18.3597C12.647 18.2631 12.7682 18.1342 12.8591 17.9732C12.953 17.8122 13 17.6334 13 17.437C13 17.1471 12.9 16.8991 12.7 16.693C12.503 16.4869 12.2697 16.3838 12 16.3838C11.7242 16.3838 11.4879 16.4869 11.2909 16.693C11.097 16.8991 11 17.1471 11 17.437C11 17.7333 11.097 17.9845 11.2909 18.1906Z"
        fill={strokeColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6107 3.69994C13.5857 1.78938 10.856 1.76106 9.79162 3.64994L1.98712 17.4996C0.954098 19.3328 2.27871 21.5997 4.38292 21.5997H19.6176C21.6966 21.5997 23.0237 19.3816 22.0409 17.5496L14.6107 3.69994ZM11.0984 4.38634C11.5822 3.52775 12.823 3.54063 13.2889 4.40906L20.7191 18.2587C21.1658 19.0915 20.5626 20.0997 19.6176 20.0997H4.38292C3.42646 20.0997 2.82436 19.0693 3.29392 18.236L11.0984 4.38634Z"
        fill={strokeColor}
      />
    </svg>
  );
};

export default HazardIcon;
